export const TOTAL_VISITORS_GRAPH = 'total-visitors';

export const AVERAGE_SECONDS_ON_WEBSITE_GRAPH = 'average-seconds-on-website';

export const TOTAL_VISITORS_CONFIG = {
  graphName: TOTAL_VISITORS_GRAPH,
  header: {
    title: { key: 'ANALYTICS.METRICS.TOTAL_VISITORS.TITLE' },
    subtitle: { key: 'ANALYTICS.METRICS.TOTAL_VISITORS.SUBTITLE' },
  },
};

export const AVERAGE_SECONDS_ON_WEBSITE_CONFIG = {
  graphName: AVERAGE_SECONDS_ON_WEBSITE_GRAPH,
  header: {
    title: { key: 'ANALYTICS.METRICS.AVERAGE_TIME_ON_WEBSITE.TITLE' },
    subtitle: { key: 'ANALYTICS.METRICS.AVERAGE_TIME_ON_WEBSITE.SUBTITLE' },
  },
};
